<template>
  <div class="travel-list__heading">
    <div>
      <button
        type="button"
        :class="[{ active: !pagingItem.showListView }, 'btn']"
        @mousedown="preventFocus"
        @click="showGridView(index)"
      >
        <span class="icon-grid_view"></span>
      </button>
      <button
        type="button"
        :class="[{ active: pagingItem.showListView }, 'btn']"
        @mousedown="preventFocus"
        @click="showListView(index)"
      >
        <span class="icon-list_view"></span>
      </button>
    </div>
    <div>
      <h2 class="fs-6 text-markpro fw-bold text-uppercase">
        Vi har fundet
        <span class="text-secondary fs-4">{{
          pagingItem.totalNumberOfResults
        }}</span>
        {{ this.$store.getters.singlePlural(pagingItem) }}
      </h2>
    </div>
  </div>
  <div
    :class="[{ initial: pagingItem.initial }, 'travel-list__overview']"
    :data-length="pagingItem.totalNumberOfResults"
    v-if="pagingItem.showListView"
  >
    <div
      class="py-5"
      v-for="(item, index) in tripfinderViewModel.result.items[index]
        .itemsListView"
      :key="index"
    >
      <h2 :id="'listviewheader' + index" class="h2 mb-4">
        <em>{{ getMonth(item.month) }} {{ item.year }}</em>
      </h2>
      <table :aria-describedby="'listviewheader' + index">
        <thead class="bg__darkblue">
          <tr class="d-none d-md-table-row">
            <th scope="col">Dato</th>
            <th scope="col">Rejse</th>
            <th scope="col">Område</th>
            <th scope="col">Varighed</th>
            <th scope="col">Pris fra</th>
          </tr>
          <tr class="d-table-row d-md-none">
            <th colspan="5" scope="col">
              {{ getMonth(item.month) }} {{ item.year }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(listItem, index) in item.items"
            :key="index"
            :class="{ even: index % 2 === 0 }"
          >
            <td data-header="Dato:">{{ listItem.dateString }}</td>
            <td data-header="Rejse:">
              <a :href="listItem.url" class="link__sand">{{
                listItem.title
              }}</a>
            </td>
            <td data-header="Område:">{{ listItem.destination }}</td>
            <td data-header="Varighed:">{{ listItem.numberOfDays }}</td>
            <td data-header="Pris fra:  ">{{ listItem.fromPrice }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <spinner v-if="isLoading" />
    <div
      class="d-flex mt-5 justify-content-center"
      v-if="
        !isLoading && pagingItem.pageNumber < pagingItem.pagesInAll
      "
    >
      <button
        type="button"
        class="btn border rounded-pill"
        @mousedown="preventFocus"
        :data-initial="pagingItem.initial"
        @click="getMoreResultItems(index)"
      >
        Vis flere
      </button>
    </div>
  </div>
  <tripfinder-result-card-view :pagingItem="pagingItem" :index="index" v-else />
</template>
<script>
import Spinner from "./Spinner.vue";
import TripfinderResultCardView from "./TripfinderResultCardView.vue";
export default {
  name: "TripfinderResultListView",
  props: ["pagingItem", "index"],
  components: {
    Spinner,
    TripfinderResultCardView,
  },
  data() {
    return {
      tableSlice: 2,
      isLoading: false
    };
  },
  computed: {
    tripfinderViewModel() {
      return this.$store.state.tripfinderViewModel;
    },
  },
  methods: {
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
    showGridView: function (index) {
      const isListView =
        this.tripfinderViewModel.paging.items[index].showListView;
      if (isListView) {
        this.tripfinderViewModel.paging.items[index].showListView = false;
        this.$store.dispatch("searchTripfinderList");
      }
    },
    showListView: function (index) {
      const isListView =
        this.tripfinderViewModel.paging.items[index].showListView;
      if (!isListView) {
        this.tripfinderViewModel.paging.items[index].showListView = true;
        this.$store.dispatch("searchTripfinderList");
      }
    },
    getMonth: function (index) {
      var months = [
        "Januar",
        "Februar",
        "Marts",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "December",
      ];
      return months[Number(index - 1)];
    },
    getMoreResultItems: function () {
      this.isLoading = true;
      this.tripfinderViewModel.paging.items[0].pageNumber += 1;
      this.$store.dispatch("searchTripfinderList", this.index).then(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>